import { fetchMethod, postMethod, putMethod, deleteMethod } from "./http.api"

const ProjectService = {

    getProject: async (id: string) => {
        return fetchMethod(`/v1/Project/project?id=${id}`);
    },

    updateProject: async (id: string) => {
        return postMethod(`/v1/Project/project/create?id=${id}`, '');
    },

    getProjectPickList: async () => {
        return postMethod(`/v1/SalesForce/Picklists`, {"inspire1__Project__c": []});
    },
    getSection4SpeciesLatinName: async (value: string) => {
        return fetchMethod(`/v1/SummaryReport/summaryReport/searchSpecies?searchText=${value}`);
    }
};

export default ProjectService;